export const SurfacelogType = 'surfaceLogType';
